import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { FIELD_DESCRIPTION, FIELD_TEXT, FIELD_TEXTAREA, FIELD_TITLE } from 'constants/fields';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Icon, TooltipMenu } from '@haldor/ui';
import './Styles.scss';

var CreateFormTemplate = /*#__PURE__*/function (_Component) {
  _inherits(CreateFormTemplate, _Component);

  var _super = _createSuper(CreateFormTemplate);

  /* Class setup */
  function CreateFormTemplate(props) {
    var _this;

    _classCallCheck(this, CreateFormTemplate);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getHighestName", function () {
      if (_this.state.fields.length > 0) {
        var max = 0;

        _this.state.fields.forEach(function (field) {
          var fieldIndex = parseInt(field.name.replace('field-', ''));

          if (fieldIndex > max) {
            max = fieldIndex;
          }
        });

        return max;
      }

      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.fields);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onValueChange", function (value, index) {
      var fields = _toConsumableArray(_this.state.fields);

      var field = _objectSpread(_objectSpread({}, fields[index]), {}, {
        value: value
      });

      fields[index] = field;
      fields.forEach(function (field, index) {
        field.sortOrder = index;
      });

      _this.setState({
        fields: fields
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMoveUp", function (index) {
      var fields = _this.state.fields;

      if (index > 0) {
        var field = fields[index];
        fields.splice(index, 1);
        fields.splice(index - 1, 0, field);
      }

      fields.forEach(function (field, index) {
        field.sortOrder = index;
      });

      _this.setState({
        fields: fields
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function (index) {
      var fields = _this.state.fields;
      fields.splice(index, 1);
      fields.forEach(function (field, index) {
        field.sortOrder = index;
      });

      _this.setState({
        fields: fields
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMoveDown", function (index) {
      var fields = _this.state.fields;

      if (index < fields.length) {
        var field = fields[index];
        fields.splice(index, 1);
        fields.splice(index + 1, 0, field);
      }

      fields.forEach(function (field, index) {
        field.sortOrder = index;
      });

      _this.setState({
        fields: fields
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addField", function (type) {
      var fields = _this.state.fields;
      var fieldIndex = _this.getHighestName() + 1;

      switch (type) {
        case FIELD_TEXT:
          fields.push({
            type: FIELD_TEXT,
            placeholder: '',
            name: 'field-' + fieldIndex
          });
          break;

        case FIELD_TEXTAREA:
          fields.push({
            type: FIELD_TEXTAREA,
            placeholder: '',
            name: 'field-' + fieldIndex
          });
          break;

        case FIELD_TITLE:
          fields.push({
            type: FIELD_TITLE,
            name: 'field-' + fieldIndex,
            value: ''
          });
          break;

        case FIELD_DESCRIPTION:
          fields.push({
            type: FIELD_DESCRIPTION,
            name: 'field-' + fieldIndex,
            value: ''
          });
          break;

        default:
          break;
      }

      fields.forEach(function (field, index) {
        field.sortOrder = index;
      });

      _this.setState({
        fields: fields
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fieldControls", function (field, index) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
        className: "field-tooltip-trigger-icon up",
        onClick: function onClick() {
          return _this.onMoveUp(index);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      })), /*#__PURE__*/React.createElement("span", {
        className: "field-tooltip-trigger-icon down",
        onClick: function onClick() {
          return _this.onMoveDown(index);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      })), /*#__PURE__*/React.createElement("span", {
        className: "field-tooltip-trigger-icon trash",
        onClick: function onClick() {
          return _this.onRemove(index);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Bin"
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderField", function (field, index) {
      if (field.type == FIELD_TITLE) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          style: {
            marginBottom: '0.85rem'
          },
          className: "form-row"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '.2rem'
          }
        }, _this.props.translate('heading'), /*#__PURE__*/React.createElement("div", {
          style: {
            "float": 'right'
          }
        }, _this.fieldControls(field, index)), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        })), /*#__PURE__*/React.createElement("input", {
          type: "text",
          value: field.value,
          onChange: function onChange(e) {
            return _this.onValueChange(e.target.value, index);
          }
        }));
      }

      if (field.type == FIELD_DESCRIPTION) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          style: {
            marginBottom: '0.85rem'
          },
          className: "form-row"
        }, /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: '.2rem'
          }
        }, _this.props.translate('description'), /*#__PURE__*/React.createElement("div", {
          style: {
            "float": 'right'
          }
        }, _this.fieldControls(field, index)), /*#__PURE__*/React.createElement("div", {
          className: "clearfix"
        })), /*#__PURE__*/React.createElement("textarea", {
          type: "text",
          value: field.value,
          rows: 2,
          onChange: function onChange(e) {
            return _this.onValueChange(e.target.value, index);
          }
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        key: index,
        style: {
          marginBottom: '0.75rem'
        },
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '.2rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, _this.fieldControls(field, index)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("div", {
        style: field.type == FIELD_TEXT ? {
          width: '100%',
          backgroundColor: '#f9f9f9',
          border: '1px solid #d9d9d9',
          color: '#7b7b7b',
          borderRadius: '3px',
          padding: '15px'
        } : {
          width: '100%',
          backgroundColor: '#f9f9f9',
          border: '1px solid #d9d9d9',
          color: '#7b7b7b',
          borderRadius: '3px',
          padding: '15px',
          height: '150px'
        }
      }, field.type == FIELD_TEXTAREA ? _this.props.translate('fields_input_textarea') : _this.props.translate('fields_input_text')));
    });

    var _fields = [];

    if (props.fields != null && props.fields.length > 0) {
      _fields = _toConsumableArray(props.fields);
    }

    _this.state = {
      fields: _fields
    };
    return _this;
  }

  _createClass(CreateFormTemplate, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var trigger = /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '1.1rem 0',
          width: '100%',
          textAlign: 'center',
          cursor: 'pointer'
        }
      }, "+ ", this.props.translate('add-content'));
      return /*#__PURE__*/React.createElement("div", {
        className: "dynamic-form create"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form form-component"
      }, this.state.fields.map(this.renderField)), /*#__PURE__*/React.createElement("div", {
        className: "add-field"
      }, /*#__PURE__*/React.createElement(TooltipMenu, {
        trigger: trigger,
        id: "dynamic-form-add-field-tooltip"
      }, /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          return _this2.addField(FIELD_TITLE);
        }
      }, this.props.translate('heading')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          return _this2.addField(FIELD_DESCRIPTION);
        }
      }, this.props.translate('description')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          return _this2.addField(FIELD_TEXT);
        }
      }, this.props.translate('fields_input_text')), /*#__PURE__*/React.createElement(TooltipMenu.Item, {
        onClick: function onClick(e) {
          return _this2.addField(FIELD_TEXTAREA);
        }
      }, this.props.translate('fields_input_textarea')))));
    }
  }]);

  return CreateFormTemplate;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}

export default connect(mapStateToProps)(CreateFormTemplate);